import type { RootState } from '@ps/web-core-store';
import { canUseDOM, getWindow } from '@ps/web-core-utils';
import type { WebsiteConfig } from '@ps/web-martech-cms-types';
import React from 'react';
import { useSelector } from 'react-redux';

import Iframe from '@swf/components/Iframe/Iframe';
import { useTouchpoint } from '@swf/components/Touchpoint';
import { select } from '@swf/core/store';

import { crm } from './EmbeddedCSAT.scss';

const getEmbeddedUserSettings = () => ({
  visitor: getWindow()?.starsweb?.touchpoint?.visitor || {},
  user_attributes: getWindow()?.starsweb?.touchpoint?.userAttributes || {}
});

const EmbeddedCSAT: React.FC = () => {
  const digitalChannelConfig = useSelector((rootState: RootState) =>
    select.cms.getWebsiteConfig(rootState, 'touchpoint')
  ) as WebsiteConfig['touchpoint'] | undefined;

  const embeddedUserSettings = canUseDOM
    ? getEmbeddedUserSettings()
    : { visitor: {}, user_attributes: {} };

  const extendedDesktopConfig = {
    ...digitalChannelConfig,
    visitor: embeddedUserSettings.visitor,
    user_attributes: embeddedUserSettings.user_attributes,
    showCloseButton: false
  };

  const { isReady, getEmbeddedUrl } = useTouchpoint(false, true, extendedDesktopConfig);

  const embeddedDistributionUrl = isReady && getEmbeddedUrl();

  return (
    embeddedDistributionUrl && (
      <div className={crm} data-testid="ces-feedback-form">
        <Iframe src={embeddedDistributionUrl} scrolling="no" />
      </div>
    )
  );
};

export default EmbeddedCSAT;
